(() => {
  const cache = new Set();

  function preload(url) {
    if (!url || cache.has(url)) return;
    const img = new Image();
    img.decoding = "async";
    img.loading = "eager";
    img.fetchPriority = "high";
    img.src = url;
    cache.add(url);
  }

  function warmCard(cardEl) {
    cardEl
      .querySelectorAll(".hzn-card-swatch[data-variant-image]")
      .forEach((btn) => preload(btn.dataset.variantImage));
  }

  function getMainImg(cardEl) {
    // Picks the first product image inside the card
    // (works on most Horizon card layouts)
    return cardEl.querySelector("img");
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-card, .product-card").forEach(warmCard);
  });

  // Catch cards loaded later (filters/infinite scroll)
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.("product-card, .product-card")) warmCard(node);
        node
          .querySelectorAll?.("product-card, .product-card")
          .forEach(warmCard);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Click: update link + swap image instantly (cached)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".hzn-card-swatch");
    if (!btn) return;

    const card = btn.closest("product-card, .product-card");
    if (!card) return;

    const url = btn.dataset.variantUrl;
    const imgUrl = btn.dataset.variantImage;

    // update card link
    const link = card.querySelector(".product-card__link");
    if (link && url) link.setAttribute("href", url);

    // swap main image
    const mainImg = getMainImg(card);
    if (!mainImg || !imgUrl) return;

    preload(imgUrl);

    card.classList.add("hzn-img-swapping");

    // If your theme uses srcset, it can fight swaps; remove it once
    if (mainImg.getAttribute("srcset")) mainImg.removeAttribute("srcset");

    if (mainImg.src !== imgUrl) {
      mainImg.decoding = "async";
      mainImg.fetchPriority = "high";
      mainImg.src = imgUrl;
    }

    requestAnimationFrame(() => {
      setTimeout(() => card.classList.remove("hzn-img-swapping"), 180);
    });
  });
})();
(() => {
  function applyHex(root = document) {
    root.querySelectorAll(".hzn-card-swatch[data-hex]").forEach((el) => {
      const hex = el.dataset.hex;
      if (hex) el.style.backgroundColor = hex;
    });
  }

  // Run a few times after load (because Horizon may overwrite after hydration)
  document.addEventListener("DOMContentLoaded", () => {
    applyHex();
    setTimeout(applyHex, 50);
    setTimeout(applyHex, 250);
    setTimeout(applyHex, 900);
  });

  // Also fix any newly injected cards (filters/infinite scroll)
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.(".hzn-card-swatch[data-hex]")) applyHex(node.parentElement || document);
        node.querySelectorAll?.(".hzn-card-swatch[data-hex]").length && applyHex(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();